import Raven from 'raven-js';
import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
//EBX638: Fetch limit usage
export const fetchLimitUsage = () => {
  return http.get(`${getFullUrl('app-api')}/feature/store/v1/usage?${PortalIdParser.get()}`).catch(error => {
    Raven.captureException(new Error('Failed to fetch limit usage - EBX638'), {
      extra: {
        error
      }
    });
    throw error;
  });
};